import { Clock } from "lucide-react";
import { useTranslate } from "ra-core";

import { ActivityLog } from "../activity/ActivityLog";
import { DashboardWidget } from "./DashboardWidget";

export function DashboardActivityLog() {
  const translate = useTranslate();
  return (
    <DashboardWidget
      icon={<Clock className="text-muted-foreground w-6 h-6" />}
      title={translate("crm.dashboard.latest_activity", {
        _: "Latest Activity",
      })}
    >
      <ActivityLog pageSize={10} />
    </DashboardWidget>
  );
}
